import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import relationshipService from '../services/relationshipService';

const relationshipsCollectionName = 'relationships';
export const useRelationship = () => {
  return useQuery({
    queryKey: [relationshipsCollectionName],
    queryFn: () => relationshipService.getAll(),
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};


export const useAddRelationship = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: relationshipService.add,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [relationshipsCollectionName] });
    },
  }); 
};

export const useEditRelationship = () => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: relationshipService.edit,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [relationshipsCollectionName] });
      },
    });
};

export const useDeleteRelationship = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: relationshipService.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [relationshipsCollectionName] });
    },
  });
};

export const useRelationshipNameById = (relationshipId) => {
  return useQuery({
    queryKey: [relationshipsCollectionName, relationshipId],
    queryFn: () => relationshipService.getNameById(relationshipId),
    enabled:!!relationshipId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useRelationshipIdByName = (relationshipName) => {
  return useQuery({
    queryKey: [relationshipsCollectionName, relationshipName],
    queryFn: () => relationshipService.getIdByName(relationshipName),
    enabled:!!relationshipName,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

